/**
 * RNC — Retail Notifications Center routes.
 *
 *   /rnc                       → admin dashboard
 *   /rnc/templates             → template library
 *   /rnc/templates/:templateName → template editor
 *   /rnc/log                   → delivery log
 *   /rnc/test                  → test-send form
 */
import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import RncDashboard from './RncDashboard';
import TemplateLibrary from './TemplateLibrary';
import TemplateEditor from './TemplateEditor';
import DeliveryLog from './DeliveryLog';
import TestSend from './TestSend';

export function RncRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RncDashboard />} />
      <Route path="templates" element={<TemplateLibrary />} />
      <Route path="templates/:templateName" element={<TemplateEditor />} />
      <Route path="log" element={<DeliveryLog />} />
      <Route path="test" element={<TestSend />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
